import clsx from 'clsx'
import { Outlet } from 'react-router-dom'
import styles from './index.module.scss'
import { requestForToken } from '../../firebase'
import earth from '../../assets/images/earth.png'
import { SelectCommon } from '../../components'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../../contexts/langContext'
import { LanguageEnum } from '../../until/constant'
const AuthPage = () => {
  const { t, i18n } = useTranslation()
  const { lang, setLang } = useLanguage()
  const handleChangeLanguage = (value: string) => {
    i18n.changeLanguage(value)
    setLang(value as LanguageEnum)
  }
  requestForToken()
  const listLang = [{label: t('language.japanese'), value: LanguageEnum.JAPANESE}, {label: t('language.english'), value: LanguageEnum.ENGLISH}]

  return (
    <div className={clsx(styles.wrapper__auth, 'auth-page-global')}>
      <div className={clsx(styles.auth__page__select)}>
        <img src={earth} alt="earth" />
        <SelectCommon 
          key={lang}
          disabled={false}
          placeholder="" 
          autoFocus={false}
          showSearch={false}
          optionFilterProp='label'
          defaultValue={lang}
          onChange={handleChangeLanguage}
          className='auth-page-select'
          dropdownStyle={{
            backgroundColor: 'transparent',
            boxShadow: 'none',
            color: 'white',
          }}
          popupClassName='lang-dropdown'
        >
          {listLang.map((item) => (
            <SelectCommon key={item.value} value={item.value}>
              {item.label}
            </SelectCommon>
          ))}
        </SelectCommon>
      </div>
      <div className={clsx(styles.auth__page)}>
        <Outlet />
      </div>
    </div>
  )
}

export default AuthPage
